import React, {useCallback, useEffect, useState} from "react";
import "../../marketplace-booking.css";
import {ProductBookingContextProvider} from "../ProductBookingContext.jsx";
import {useRequest} from "../../../../utils/hooks.jsx";
import {constructBudgetObject} from "../../../../company/CompanyAccountProfile/utils.jsx";
import {isEmpty} from "lodash";
import {PriceTypes} from "../../../../admin/upload/PriceSelectorHelper.jsx";
import {updateCompanyFinanceContact} from "../../../../api/company/index.jsx";
import {ProductBookingAsClient} from "./ProductBookingAsClient.jsx";

export const ProductBookingAsClientWrapper = ({history, match}) => {
    const {userId} = match?.params ?? {};
    const [userBooking, setUserBooking] = useState({});

    const [userMe = {}, isLoadingMe, errorMe, fetchMe] = useRequest(`/api/users/me/${userId}`);
    const [companyMe = {}, isLoadingCompany, errorCompany, fetchCompany] = useRequest(
        `/api/companies/info/${userMe?.companyId}`,
        "GET",
        null,
        [userMe?.companyId],
        !!userMe?.companyId
    );

    const [userBudget = [], isLoading, error, fetchUserBudget] = useRequest(
        `/api/budget/user/${userMe?.userId}`,
        "GET",
        null,
        [userMe?.userId],
        !!userMe?.userId
    );

    const [services = []] = useRequest(
        `/api/categories/users/${userMe?.userId}`,
        "GET",
        null,
        [userMe?.userId],
        !!userMe?.userId,
        null,
        []
    );

    useEffect(() => {
        if (!isEmpty(userMe)) {
            setUserBooking(me => ({...userMe}));
        }
    }, [userMe]);

    useEffect(() => {
        if (!isEmpty(userBudget)) {
            const budget = constructBudgetObject(userBudget);

            setUserBooking(me => ({...me, budget}));
        }
    }, [userBudget]);

    const onSaveMeCompanyFinanceContact = useCallback(
        async financeContact => {
            await updateCompanyFinanceContact(userBooking, financeContact);
        },
        [userBooking]
    );

    return (
        <ProductBookingContextProvider
            history={history}
            services={services}
            me={userBooking}
            company={companyMe}
            shouldNotifyOnWindowExit={false}
            onSyncUserBudget={fetchUserBudget}
            fetchMe={fetchMe}
            fetchCompany={fetchCompany}
            onSaveCompanyFinanceContact={onSaveMeCompanyFinanceContact}
            allowEmptyPackageByPriceType={[PriceTypes.ByModular]}>
            <ProductBookingAsClient />
        </ProductBookingContextProvider>
    );
};
